import { DistributorsConfigFormTemplateFormSectionName, DistributorConfigFieldUpdateCallback } from 'data/template/template.types';
import { useDistributorConfigFieldCreateNewSecurityInfo } from './useDistributorConfigFieldCreateNewSecurityInfo';

// eslint-disable-next-line import/prefer-default-export
export function useDistributorConfigFieldCreateNew(
  handleFieldUpdate: DistributorConfigFieldUpdateCallback,
): [DistributorConfigFieldUpdateCallback] {
  const [handleFieldSecurityInfo] = useDistributorConfigFieldCreateNewSecurityInfo(handleFieldUpdate);

  const handleFieldCreateNew: DistributorConfigFieldUpdateCallback = (param, formSection, interfaceId) => {
    const { name } = param;

    if (
      formSection === DistributorsConfigFormTemplateFormSectionName.listeners ||
      formSection === DistributorsConfigFormTemplateFormSectionName.destinations
    ) {
      if (name === 'secInfoId') {
        handleFieldSecurityInfo(param, formSection, interfaceId);
      }
    }
  };

  return [handleFieldCreateNew];
}
